<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <path
            d="M3.94306 2.06641C3.57705 2.06639 3.26224 2.06638 3.01715 2.08828C2.783 2.1092 2.47448 2.1575 2.22991 2.36268C1.9233 2.6199 1.75629 3.0069 1.77947 3.40645C1.79797 3.72515 1.97448 3.98276 2.11989 4.16748C2.27209 4.36083 2.48805 4.58986 2.73916 4.85617L6.39916 8.738L6.39915 13.665C6.39911 13.7368 6.39907 13.8264 6.40617 13.904C6.4137 13.9862 6.43501 14.1474 6.54359 14.3026C6.66971 14.4829 6.86454 14.6033 7.08223 14.6355C7.26964 14.6632 7.4233 14.6102 7.50026 14.5801C7.57282 14.5518 7.65288 14.5117 7.71705 14.4796L9.09058 13.7928L9.09973 13.7884C9.14059 13.7688 9.26963 13.7071 9.37068 13.6039C9.45365 13.5192 9.51676 13.4171 9.55542 13.305C9.60251 13.1684 9.60006 13.0254 9.59928 12.9801L9.59915 12.9699V8.738L13.2591 4.85618C13.5102 4.58986 13.7262 4.36083 13.8784 4.16748C14.0238 3.98276 14.2003 3.72515 14.2188 3.40645C14.242 3.0069 14.075 2.6199 13.7684 2.36268C13.5238 2.1575 13.2153 2.1092 12.9812 2.08828C12.7361 2.06638 12.4213 2.06639 12.0553 2.06641H3.94306Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'filter-icon',
    props: {
        width: {
            type: [String, Number],
            default: 16,
        },
        height: {
            type: [String, Number],
            default: 16,
        },
        // Tailwind text color class, e.g. 'text-content-basic-3'
        color: {
            type: String,
            default: 'text-[#666666]',
        },
    },
};
</script>

